import { CUSTOM_ROSTER_SELECTION_TYPE, FILE_UPLOAD_RESPONCE } from '@/utils/constants';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { rosterAPI } from '@/providers/apis/roster/roster';
import moment from 'moment';
import { isAPICatchError, isEmptyValue } from '@/utils/utils';

@Component({
    name: 'enrollment-details',
    components: {},
})

export default class RosterEnrollmentDetails extends Vue {

    // -------------------------------------------------------------------
    // Properties
    @Prop()
    private rosterData: any;

    private enrollmentList: any = [];

    private isLoading: boolean = false;

    private offset: number = 0;

    private limit: number = 10;

    private totalLength: number = 0;

    private currentPage: number = 1;

    private pageLimit: number = 10;


    public created() {

        this.isLoading = true;
        this.fetchEnrollmentList();
        this.arrayToObject();
    }


    // --------------------------------------------------------------------
    // Events


    // ---------------------------------------------------------------------
    // Actions
    private onClose() {
        this.$emit('onClose');
    }

    private onSelectPage(item: number) {
            this.isLoading = true;
            this.currentPage = item;
            this.offset = (item - 1) * this.pageLimit;
            this.fetchEnrollmentList();
    }

    // ---------------------------------------------------------------------
    // Methods
    private fetchEnrollmentList() {
        const params = {
            zipId: this.rosterData.id,
            offset: this.offset,
            limit: this.limit,
            is_required_sync: this.rosterData.showError,
        };

        rosterAPI.getEnrollmentDetails(params).then(async (uploadList) => {
            this.isLoading = false;
            if (!isAPICatchError(uploadList)) {
                if (uploadList.enrollments && uploadList.enrollments.length > 0) {
                    await this.mapErrorMessages(uploadList.enrollments);
                }
                this.enrollmentList = uploadList.enrollments;
                this.totalLength = uploadList.totalEnrollmentsCount;
            }
        });
    }

    private async mapErrorMessages(uploadEnroll: any) {
        for await (const iterator of uploadEnroll) {
            if (isEmptyValue(iterator.syncStatusMessage) ||
                isEmptyValue(iterator.syncStatusMessage.message)) {
                iterator.syncStatusMessage = {};
                iterator.syncStatusMessage.message =
                    this.rosterData.errorMessage[iterator.userSourcedId];
            }
        }
    }

    private arrayToObject() {
        this.rosterData.errorMessage = {};
        if (this.rosterData.uploadStatistics && this.rosterData.uploadStatistics.enrollment_errors) {
            this.errorMapping(this.rosterData.uploadStatistics.enrollment_errors);
        } else if (this.rosterData.uploadStatistics && this.rosterData.uploadStatistics.users_errors) {
            this.errorMapping(this.rosterData.uploadStatistics.users_errors);
        }
    }

    private errorMapping(list: any) {
        for (const iterator of list) {
            for (const key in iterator) {
                if (Object.prototype.hasOwnProperty.call(iterator, key)) {
                    this.rosterData.errorMessage[key] = iterator[key];
                }
            }
        }

    }
}
